import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SecurityContextService } from '@services/security_context.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const securityContextService = inject(SecurityContextService);

  const authenticatedRequest = securityContextService.authData()?.token
    ? req.clone({
        headers: req.headers.set(
          'Authorization',
          `Bearer ${securityContextService.authData().token}`,
        ),
      })
    : req;

  return next(authenticatedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.log('unauthorized');
        securityContextService.logOut();
      }

      // Rethrow the error to propagate it to the caller
      return throwError(() => error);
    }),
  );
}
